import {Injectable} from '@angular/core';
import {IoService} from './io.service';
import {TechDocType} from '../models';

@Injectable()
export class TechDocTypeService extends IoService {
  protected model = TechDocType;
  protected listUrl = '/pdf-type/';
}
